import React, { useState } from 'react'

import { Edit as EditIcon, Home as HomeIcon } from '@material-ui/icons'

import { CarrierDialog } from 'src/modules/supply_chain/components/CarrierDialog'
import { ValueField } from 'src/components/Table'
import { DetailComponent } from './base'

interface ObjInfo {
  data: any
  isLoading: boolean
}

interface DetailTableProps {
  obj: ObjInfo
  refresh?: () => void
}

export const CarrierDetailTable = (props: DetailTableProps) => {
  const { obj, refresh } = props
  const [updateOpen, setUpdateOpen] = useState(false)

  return (
    <>
      {updateOpen && (
        <CarrierDialog
          open={updateOpen}
          carrier={obj.data}
          update
          handleClose={() => {
            setUpdateOpen(false)
          }}
          onSave={refresh}
        />
      )}
      <DetailComponent
        obj={obj}
        Icon={HomeIcon}
        menuItems={[
          { Icon: EditIcon, actions: [{ title: 'Edit Carrier', onClick: () => setUpdateOpen(true) }] },
        ]}
        fields={[
          { id: 'guid', label: 'SquID', renderer: ValueField },
          { id: 'name', label: 'Name', renderer: ValueField },
          { id: 'scac', label: 'SCAC Code', renderer: ValueField },
          { id: 'carrierTypeDisplay', label: 'Type', renderer: ValueField },
        ]}
      />
    </>
  )
}
